import React from 'react';
import FaPlus from 'react-icons/lib/fa/plus';
import FaMinus from 'react-icons/lib/fa/minus';
import cx from 'classnames';

export default class ResourceCard extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      expanded: false,
    }
  }

  onExpandClick(){
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  getResources(){
    let numResources = this.props.resources.length;
    let resources = [];
    for(let i = 0; i < numResources; i++){
      let resourceData = this.props.resources[i];
      if(resourceData){
        let resourceStyles = cx({
         'resource': true,
         'hidden': i != 0 && !this.state.expanded,
        });

        resources.push(
          <div className={resourceStyles} key={"resource" + resourceData.title + i}>
            <img className="resourceImage" src={resourceData.typeUrl}></img>
            <div className="resourceLinkContainer">
              <a className="resourceLink" href={resourceData.resourceUrl} target="_blank">{resourceData.title}</a>
              <div className="printedUrl">{resourceData.resourceUrl}</div>
              <img className="partnerImage" src={resourceData.brandingUrl}></img>
            </div>
          </div>
        );
      }
    }
    if(resources.length > 0){
      let resourcesStyles = cx({
        'resources': true,
        'wide': !(this.props.examples && this.props.examples.length > 0),
      });
      return (
        <div className={resourcesStyles}>
          <div className="resourcesTitle">RESOURCES</div>
          {resources}
        </div>
      );
    } else {
      return null;
    }
  }

  getExpandButton(){  
    if(!(this.props.resources && this.props.resources.length > 1)){
      return null;
    }
    if(this.state.expanded){
      return (
        <div className="expandButton" onClick={this.onExpandClick.bind(this)}>
          <FaMinus size="16" className="expandIcon"/>
          Show Fewer Resources
        </div>
      );
    } else {
      return (
        <div className="expandButton" onClick={this.onExpandClick.bind(this)}>
          <FaPlus size="16" className="expandIcon"/>
          View More Resources
        </div>
      );
    }
  }

  getExamples(){
    if(!(this.props.examples && this.props.examples.length > 0)){
      return null;
    } else {
      return (
        <div className="examples">
          <div className="examplesTitle">EXAMPLES</div>
          <div className="examplesText">{this.props.examples.join(", ")}</div>  
        </div>
      );
    }
  }

  render() {
    let resourcesExist = this.props.resources && this.props.resources.length > 0;
    let examplesExist = this.props.examples && this.props.examples.length > 0;
    if(!resourcesExist && !examplesExist){
      return null;
    }
    return (
      <div className="ResourceCard">
        <div className="resourceCardTitle">{this.props.title}</div>
        <div className="resourceCardContents">
          {this.getResources()}
          {this.getExamples()}
          {this.getExpandButton()}
        </div>
      </div>
    );
  }
}





